import { useLayoutEffect, useRef, useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { FAST_ANIMATION_DURATION_MS } from "app/modules/project-from-comparison/config";
import { useProjectCreation } from "app/modules/project-from-comparison/context";
import projectCreatingTrack from "app/modules/project-from-comparison/tracking";
import { ProjectErrors } from "app/modules/project-from-comparison/types";

import * as SC from "./styles";

export const ErrorMessage = () => {
    const { errors } = useProjectCreation();
    const { translate } = useTranslate();
    const [shouldShow, setShouldShow] = useState(false);

    const text = errors[ProjectErrors.SameCompetitors] && translate("project.creation.errors.sameCompetitors");

    const contentRef = useRef<HTMLDivElement>(null);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<string>("0px");

    useLayoutEffect(() => {
        setShouldShow(true);
        const wrapperEl = wrapperRef.current;
        const contentEl = contentRef.current;

        if (!wrapperEl || !contentEl) {
            return;
        }

        if (text) {
            const measuredHeight = contentEl.scrollHeight;
            setHeight(`${measuredHeight}px`);

            projectCreatingTrack.trackProjectCreationDuplicatedProjectErrorShow();

            const handleTransitionEnd = () => {
                setHeight("auto");
                wrapperEl.removeEventListener("transitionend", handleTransitionEnd);
            };
            wrapperEl.addEventListener("transitionend", handleTransitionEnd);
        } else {
            const currentHeight = wrapperEl.getBoundingClientRect().height;
            if (currentHeight === 0) {
                setHeight("0px");
                return;
            }
            setHeight(`${currentHeight}px`);
            requestAnimationFrame(() => {
                setHeight("0px");
            });

            setTimeout(() => {
                setShouldShow(false);
            }, FAST_ANIMATION_DURATION_MS);
        }
    }, [text]);

    if (!text && !shouldShow) {
        return null;
    }

    return (
        <SC.AnimatedWrapper
            ref={wrapperRef}
            $height={height}
        >
            <SC.Container
                ref={contentRef}
                role="status"
                aria-live="polite"
            >
                {text}
            </SC.Container>
        </SC.AnimatedWrapper>
    );
};
